import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, TIPO_DE_CONTAINER_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TIPO_DE_CONTAINER_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      TIPO_DE_CONTAINER_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TIPO_DE_CONTAINER_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [TIPO_DE_CONTAINER_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [TIPO_DE_CONTAINER_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TIPO_DE_CONTAINER_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TIPO_DE_CONTAINER_ENDPOINT],
    id
  );
}
